import { Dispatch, SetStateAction } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import theme from '@ilg-totallymoney/ui/theme'

const ReviewsPagination = ({
    numberOfReviews,
    selected,
    setSelected,
}: {
    numberOfReviews: number
    selected: number
    setSelected: Dispatch<SetStateAction<number>>
}) => (
    <Box
        display={['none', 'grid']}
        gridColumn="1/13"
        gridTemplateColumns={`repeat(auto-fit, ${theme.space10})`}
        gridColumnGap="space20"
        mb={[0, 'space30', 'space50']}
        justifyContent="center"
    >
        {Array.from({ length: numberOfReviews }, (_, index) => {
            const isSelected = selected === index

            return (
                <Box
                    backgroundColor={isSelected ? 'indigo60' : 'grey40'}
                    borderRadius="borderRadius30"
                    //@ts-ignore
                    css={{
                        ':hover': {
                            cursor: !isSelected ? 'pointer' : 'cursor',
                        },
                    }}
                    size="8px"
                    onClick={() => setSelected(index)}
                    key={`review-${index}`}
                />
            )
        })}
    </Box>
)

export default ReviewsPagination
